<h4 matDialogTitle>Please enter name for this saved search.</h4>
<mat-dialog-content>
  <form class="form mb-4">
    <mat-form-field style="width: 100%;" appearance="fill">
      <mat-label>Name</mat-label>
      <input type="text" matInput [formControl]="nameFormControl" placeholder="Ex. My saved search">
      <mat-error *ngIf="nameFormControl.hasError('nameError')">
        This name already exists. Please enter another name
      </mat-error>
      <mat-error *ngIf="nameFormControl.hasError('required')">
        Name is <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="nameFormControl.hasError('whitespace')">
        Please enter valid name
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" [disabled]="!nameFormControl.valid" type="submit" (click)="save()">Submit</button> &nbsp;&nbsp;
  <button mat-raised-button type="cancel" (click)="cancel()">Cancel</button>
</mat-dialog-actions>

